import { Bags } from '@shared/interfaces/project/bags.interface';
import { User } from '@shared/models/user/user.model';
import { Config } from '@shared/config';
import { ProjectStatus } from '@shared/interfaces/project/project-status.interface';
import { CreatedReport } from '@shared/interfaces/project/created-report.interface';
import * as moment from 'moment';
import { Tag } from '@shared/interfaces/project/tag.interface';

export class Project {
  id?: number;
  status: number;
  name: string;
  categories: Tag[];
  country: string;
  continent: string;
  created_at: string;
  description_one: string;
  description_two: string;
  description_three: string;
  description_four: string;
  latitude: string;
  longitude: string;
  days_to_end: number;
  end_job_date: string;
  donated_money: string | number = 0;
  main_picture: string;
  bags: Bags[];
  user: User;
  video: string;
  display_gallery_images: string[];
  bagsCount: number = 0;
  people_donated: number;
  gathered_money: number;
  view_counter: number;
  automatic_close: boolean = false;
  img_after: string;
  img_before: string;
  img_leave_trash: string;
  last_activity: string;
  main_page_add_date: string;
  project_reports: CreatedReport[];
  promoted: any;
  thumbnail: any;
  vote_counter: number;
  closed_at: string;
  rate_count: number = 0;
  organization?: any;
  from_event?: boolean;
  organization_id?: number;
  participant_counter?: number;
  participant_guest?: number;
  currency?: string;
  goal_amount: string;

  constructor(data?: any) {
    Object.assign(this, data);

    this.countBags();
  }

  countBags() {
    const bags =
      this.bags && this.bags.length
        ? this.bags.filter((el) => el.count).map((el: Bags) => el.count)
        : [];
    this.bagsCount = bags.length > 0 ? bags.reduce((total, count) => total + count) : 0;
  }

  get projectStatus(): ProjectStatus {
    return Config.PROJECT_STATUS[this.status - 1];
  }

  get dateFromNow() {
    return moment(this.created_at, Config.DATE_FORMAT_BACKEND).fromNow();
  }

  get fullMainImg() {
    return this.main_picture
      ? this.main_picture.substring(0, this.main_picture.lastIndexOf('/')) +
          '/' +
          this.main_picture.split('/')[7]
      : 'assets/img/icons/img-placeholder.webp';
  }

  get mainImg() {
    return this.main_picture
      ? this.main_picture.substring(0, this.main_picture.lastIndexOf('/')) +
          '/thumbs/' +
          this.main_picture.split('/')[7]
      : 'assets/img/icons/img-placeholder.webp';
  }

  get mainImgSmall() {
    return this.main_picture
      ? this.main_picture.substring(0, this.main_picture.lastIndexOf('/')) +
          '/tinyThumbs/' +
          this.main_picture.split('/')[7]
      : 'assets/img/icons/img-placeholder.webp';
  }
}
